import type React from 'react';
import styled from 'styled-components';

export interface SymmetricalQuadroLayoutProps {
  topLeftContent: React.ReactNode;
  topRightContent: React.ReactNode;
  bottomLeftContent: React.ReactNode;
  bottomRightContent: React.ReactNode;
  footerContent: React.ReactNode;
  maximizedArea?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
}

export const SymmetricalQuadroLayout: React.FC<SymmetricalQuadroLayoutProps> = ({
  topLeftContent,
  topRightContent,
  bottomLeftContent,
  bottomRightContent,
  footerContent,
  maximizedArea
}) => {
  return (
    <Container data-testid="quadro-viewport-layout">
      <ContentArea>
        <ContentPlaceholder $isMaximized={maximizedArea === 'topLeft'}>{topLeftContent}</ContentPlaceholder>
        <ContentPlaceholder $isMaximized={maximizedArea === 'topRight'}>{topRightContent}</ContentPlaceholder>
        <ContentPlaceholder $isMaximized={maximizedArea === 'bottomLeft'}>{bottomLeftContent}</ContentPlaceholder>
        <ContentPlaceholder $isMaximized={maximizedArea === 'bottomRight'}>{bottomRightContent}</ContentPlaceholder>
      </ContentArea>
      <FooterPlaceholder>{footerContent}</FooterPlaceholder>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const ContentArea = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  position: relative;
`;

const ContentPlaceholder = styled.div<{ $isMaximized: boolean }>`
  position: ${({ $isMaximized }): string => ($isMaximized ? 'absolute' : 'initial')};
  width: ${({ $isMaximized }): string => ($isMaximized ? '100%' : 'calc(50% - 3px)')};
  inset: 0;
  z-index: ${({ $isMaximized }): number => ($isMaximized ? 1000 : 0)};
`;

const FooterPlaceholder = styled.div``;
